import { visionLabApi } from '@/app/apiClient';
import type { CreateDeviceTypeInput, DeviceType } from '@/features/device-types/types/deviceTypes';
import type { ApiCallOptions } from '@/shared/api/client';

export function fetchDeviceTypes(options: ApiCallOptions = {}) {
  return visionLabApi.get<DeviceType[]>('/device-types', options);
}

export function createDeviceType(body: CreateDeviceTypeInput) {
  return visionLabApi.post<DeviceType>('/device-types', { json: body });
}
